module.exports = __webpack_public_path__ + "img/9.43110c3a.jpg";